import { atom } from "recoil";
import { AlertStatus } from "@chakra-ui/react";

export interface AppToast {
  id: string;
  status: AlertStatus;
  message: string;
  // 안내 문구 아래에 덧붙이는 보조 줄 (서버가 준 실패 사유 등)
  description?: string;
}

export const appToastsState = atom<AppToast[]>({
  key: "AppToasts",
  default: [],
});
